import { DatePipe } from '@angular/common';
import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { StartFromPipe } from '../../filters/start-from.pipe';
import { TranslatePipe } from '../../filters/translate.pipe';
import { ItemNoContentComponent } from '../../components/item-no-content/item-no-content.component';
import { LoaderOverlayComponent } from '../../components/loader-overlay/loader-overlay.component';
import { Component, OnInit, OnDestroy, inject } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import DialogServices from '../../services/dialog.service';
import RestService from '../../services/core-rest.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import { Input, Output, EventEmitter } from '@angular/core';
import { ModalRejectJoinRequestComponent } from '../modal-reject-join-request/modal-reject-join-request.component';
import { Subscription, Subject } from 'rxjs';
import { debounceTime } from 'rxjs/operators';

@Component({
	standalone: true,
	selector: 'table-join-requests',
	templateUrl: './table-join-requests.component.html',
	imports: [
		CommonModule, DatePipe, ArrayLimitToPipe, StartFromPipe, 
		TranslatePipe, ItemNoContentComponent, LoaderOverlayComponent, FormsModule
	]
})
export class TableJoinRequestsComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private dialogServices: DialogServices = inject(DialogServices);
	private restService: RestService = inject(RestService);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	@Input() joinRequests: any;
	@Output() joinRequestsChange: EventEmitter<any> = new EventEmitter<any>();
	@Input() pageSize: any | undefined;
	@Input() currentPage: any | undefined;
	@Output() currentPageChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	
	searchSubject: Subject<string> = new Subject<string>();
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor() {
		this.vm = this;
		
		this.searchSubject.pipe(
			debounceTime(500)
		).subscribe(searchTerm => {
			this.loadJoinRequests(true);
		});
	}
	
	ngOnInit() {
		this.vm.filter = {
			orderBy: 'created',
			ascending: false
		};
		this.vm.pageSize = this.vm.pageSize || 10;
		this.vm.currentPage = this.vm.currentPage || 0;
		this.vm.endReached = false;
		this.vm.loading = true;
		this.loadJoinRequests(true, true);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, "loadMorePages", () => {
				if (!this.vm.endReached) {
					this.loadJoinRequests();
				}
			})
		);
		
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this, this.config.getBroadcastConfig().Employees.ADDED, () => {
				this.loadJoinRequests(true);
				this.vm.currentPage = 0;
			})
		);
		
		this.vm.loadJoinRequests = this.loadJoinRequests;
		this.vm.activate = this.activate;
		this.vm.reject = this.reject;
		this.vm.setFilter = this.setFilter;
	}
	
	ngOnDestroy() {
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	onSearchChange(searchTerm: string) {
		this.searchSubject.next(searchTerm);
	}
	
	loadJoinRequests(isInitial?, hasLoader?) {
		if (isInitial) {
			this.vm.endReached = false;
		} else if (this.vm.endReached) {
			this.vm.loading = false;
			return;
		}
		var params: any = {
			pageSize: this.vm.pageSize * 2,
			start: (!isInitial && this.vm.joinRequests) ? this.vm.joinRequests.length : 0,
			orderBy: this.vm.filter.orderBy || 'created',
			ascending: this.vm.filter.ascending || false
		};
		if (this.vm.term && this.vm.term.trim() && this.vm.term.trim().length > 1) params.name = this.vm.term.trim();
		
		this.restService.getBusinessUserJoinRequests(params)
			.then((joinRequests) => {
				if (joinRequests && joinRequests.length < this.vm.pageSize * 2) {
					this.vm.endReached = true;
				}
				if (isInitial) this.vm.currentPage = 0;
				if (hasLoader) {
					this.angularHelperService.createTimer(() => {
						this.vm.loading = false;
						this.vm.joinRequests = isInitial ? joinRequests : this.vm.joinRequests.concat(joinRequests);
						this.joinRequestsChange.emit(this.vm.joinRequests);
					}, this.config.getOtherConfig().LOADER_TIMEOUT_DELAY);
				} else {
					this.vm.joinRequests = isInitial ? joinRequests : this.vm.joinRequests.concat(joinRequests);
					this.joinRequestsChange.emit(this.vm.joinRequests);
				}
			})
			.catch((error) => {
				console.log(error);
			});
	}
	
	setFilter(name) {
		this.vm.filter = this.vm.filter || {};
		this.vm.filter.ascending = this.vm.filter.orderBy === name ? !this.vm.filter.ascending : false;
		this.vm.filter.orderBy = name;
		
		this.loadJoinRequests(true);
	}
	
	activate(joinRequest) {
		if (!joinRequest) return;
		
		this.restService.saveBusinessUserJoinRequestAccept(joinRequest)
			.then((response) => {
				this.vm.joinRequests = this.vm.joinRequests.map(function(request) {
					if (request.id === response.id) {
						request.status = response.status;
					}
					return request;
				});
			})
			.catch((error) => {
				console.log(error);
			});
	}
	
	reject(joinRequest) {
		if (!joinRequest) return;
		
		var dialog = this.dialogServices.show({
			controller: ModalRejectJoinRequestComponent,
			joinRequest: joinRequest,
			clickOutsideToClose: false,
			escapeToClose: false,
			multiple: false
		});
		dialog.afterClosed().subscribe(
			(response) => {
				if (response) {
					this.vm.joinRequests = this.vm.joinRequests.map(function(request) {
						if (request.id === response.id) {
							request.status = response.status;
						}
						return request;
					});
				}
			},
			(error) => {
				console.log(error);
			}
		);
	}
	
}